const initState = {}

export function jobs(state = initState, action) {
  switch (action.type) {
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/Jobs/reducer.js